// v2.16-A (owner 2026-10-22, requirement 75 butir 9a): the running timer per station. Pure helpers (no
// imports) so Jest can test them. The clock is the SERVER's: the page keeps the offset between the
// server time it last received and the browser clock, so a phone with a wrong clock still shows the
// right elapsed time.

// ms to add to Date.now() to get the server time (server ISO time received at browser time `kiniMs`)
export function offsetJam(jamServerIso, kiniMs) {
  const t = Date.parse(jamServerIso || "");
  if (Number.isNaN(t)) return 0;
  return t - kiniMs;
}

// seconds elapsed since `mulaiIso` at server-corrected browser time `kiniMs` (+ offset); never negative
export function detikSejak(mulaiIso, kiniMs, offsetMs = 0) {
  const t = Date.parse(mulaiIso || "");
  if (Number.isNaN(t)) return null;
  return Math.max(0, Math.floor((kiniMs + offsetMs - t) / 1000));
}

// "mm:ss" under an hour, "h:mm:ss" from one hour, "N hari hh:mm" from one day on; null/undefined -> ""
export function formatDurasi(detik) {
  if (detik == null || Number.isNaN(Number(detik))) return "";
  const d = Math.max(0, Math.floor(Number(detik)));
  const hari = Math.floor(d / 86400);
  const h = Math.floor((d % 86400) / 3600), m = Math.floor((d % 3600) / 60), s = d % 60;
  const hh = String(h).padStart(2, "0"), mm = String(m).padStart(2, "0"), ss = String(s).padStart(2, "0");
  if (hari > 0) return `${hari} hari ${hh}:${mm}`;
  return h > 0 ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
}

// queue rows that are new and waiting since the previous poll: the station gets a short sound for them
// (v2.16-A butir 9b). `kunci(q)` identifies a row; only PENDING rows count; the first poll is silent.
export function kunciBaris(q) {
  return `${q.spk_id}|${q.instance_id}|${q.urutan}|${q.bagian_id || ""}|${q.rework ? q.rework.rework_ke || 0 : 0}`;
}

export function barisBaru(sebelum, rows) {
  if (!sebelum) return [];
  return (rows || []).filter((q) => q.status === "PENDING" && !sebelum.has(kunciBaris(q)));
}
